import './dashboard-page.css';

import { Card, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useGetLatestIncidentsQuery, useGetUnmappedIncidentsQuery } from '../../redux/api/incidents';
import { useGetRecentFailedTransmissionLogsQuery } from '../../redux/api/transmission-logs';
import { useGetStaleClientsQuery } from '../../redux/api/clients';
import SuccessRateChart from '../../component/success-rate-chart';

const DashboardPage = () => {

    const navigate = useNavigate();
    const { data: incidents } = useGetLatestIncidentsQuery(null);
    const { data: failedTransmissions } = useGetRecentFailedTransmissionLogsQuery(null);
    const { data: staleClients } = useGetStaleClientsQuery(undefined);
    const { data: unmappedIncidents } = useGetUnmappedIncidentsQuery(undefined);

    return (
        <div className="dashboard-page-container">
            <h1>Dashboard</h1>
            <div className="dashboard-content">
                <div className="center-dashboard">
                    <Card className="dashboard-widget-card">
                        <SuccessRateChart />
                    </Card>
                    <Card className="dashboard-widget-card">
                        <div className="stat-card">
                            <div className="stat-card-header panel-header-link" onClick={() => navigate('/clients')}>
                                Stale Clients
                            </div>
                            <div className="stat-card-hero">
                                <span className={`stat-card-value${(staleClients?.page?.totalSize ?? 0) > 0 ? ' is-bad' : ''}`}>
                                    {staleClients?.page?.totalSize ?? 0}
                                </span>
                                <span className="stat-card-sub">scheduled clients with no successful transmission in 24h</span>
                            </div>
                            {(staleClients?.items?.length ?? 0) > 0 ? (
                                <div className="stat-card-list">
                                    {staleClients.items.map((client: any, index: number) => (
                                        <div key={index} className="stat-card-list-item">
                                            <span>{client.name}</span>
                                            <span>
                                                {client.lastTransmissionDate
                                                    ? new Date(client.lastTransmissionDate + 'Z').toLocaleString()
                                                    : 'Never transmitted'}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="stat-card-empty">No stale clients.</div>
                            )}
                        </div>
                    </Card>
                    <Card className="dashboard-widget-card">
                        <div className="stat-card">
                            <div className="stat-card-header panel-header-link" onClick={() => navigate('/citations')}>
                                Unmapped Incidents
                            </div>
                            <div className="stat-card-hero">
                                <span className={`stat-card-value${(unmappedIncidents?.page?.totalSize ?? 0) > 0 ? ' is-bad' : ''}`}>
                                    {unmappedIncidents?.page?.totalSize ?? 0}
                                </span>
                                <span className="stat-card-sub">citations received in the last 30 days with no client mapping</span>
                            </div>
                            {(unmappedIncidents?.items?.length ?? 0) > 0 ? (
                                <div className="stat-card-list">
                                    {unmappedIncidents.items.map((incident: any, index: number) => (
                                        <div key={index} className="stat-card-list-item">
                                            <span>Incident {incident.incidentId}</span>
                                            <span>Court {incident.courtId} / Dept {incident.departmentId}</span>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="stat-card-empty">No unmapped incidents.</div>
                            )}
                        </div>
                    </Card>
                </div>
                <div className="footer-dashboard">
                    <div className="widget-panel">
                        <div className="panel-header panel-header-link" onClick={() => navigate('/citations')}>Recent Incidents</div>
                        <div className="panel-content">
                            <div className="incident-list">
                                {incidents?.map((incident: any, index: number) => <div key={index} className="incident-item">
                                    <div className="incident-id">{incident.incidentId}</div>
                                    <div className="department-id">Dept ID: {incident.departmentId}</div>
                                    <div className="court-id">Court ID: {incident.courtId}</div>
                                    <div className="incident-date">{new Date(incident.createdAt + "Z").toLocaleString()}</div>
                                </div>)}
                            </div>
                        </div>
                    </div>
                    <div className="widget-panel">
                        <div className="panel-header panel-header-link" onClick={() => navigate('/transmission-logs')}>Failed Transmissions</div>
                        <div className="panel-content">
                            <div className="failed-transmission-list">
                                {failedTransmissions?.map((log: any, index: number) => <div key={index} className="failed-transmission-item">
                                    <div className="failed-transmission-client">{log.client?.name}</div>
                                    <div className="failed-transmission-status"><Tag color="red">FAIL</Tag></div>
                                    <div className="failed-transmission-date">{new Date(log.occurredAt + "Z").toLocaleString()}</div>
                                </div>)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default DashboardPage;

